import React from "react";
import styled from "styled-components";

const SidebarContainer = styled.div`
  position: fixed;
  width: 100px;
  height: 100vh;
  background-color: #2c3e50;
  color: #ecf0f1;
  flex-direction: column;
  padding: 20px;
  top: 0;
  left: 0;
`;

const NavItem = styled.div`
  padding: 15px;
  margin: 10px 0;
  cursor: pointer;
  &:hover {
    background-color: #34495e;
  }
`;

const Sidebar = () => {
  return (
    <SidebarContainer>
      <NavItem>Dashboard</NavItem>
      <NavItem>Settings</NavItem>
      <NavItem>Profile</NavItem>
    </SidebarContainer>
  );
};

export default Sidebar;
